// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_BuscaFotosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/imagens_servicos/busca_fotos/{servicoId}/{antesDepois}
 *
 * Fetches photos for a service item. No body required —
 * servicoId and antesDepois are URL path parameters.
 */
import { registerContract } from './validate'

export interface ImagensServicos_BuscaFotosInput {}

registerContract('ImagensServicos_BuscaFotosInput', {})
